import { DateTime } from 'luxon';
import utilityHelper from './utilityHelper';

export default class dateHelper {

    static isValidDate(dValue: string): boolean {
        if (utilityHelper.isNullOrEmpty(dValue)) {
            return false;
        }
        var isoDate = dateHelper.stringToDate(dValue);
        if (isoDate) {
            // This is an ISO formatted date
            return true;
        }
        return false;

    }
    static tabulatorDateFormatter() {
        return function (cell: any, formatterParams: any) {
            const { outputFormat = "MM/dd/yyyy" } = formatterParams;
            let options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
            let value = cell.getValue();
            if (value) {
                var isoDate = dateHelper.stringToDate(value);
                if (isoDate) {
                    // This is an ISO formatted date
                    return new Intl.DateTimeFormat('en-US', options).format(isoDate);
                }
                return "Invalid date:" + value; //DateTime.fromISO(value).toFormat(outputFormat);
            } else {
                return "";
            }
        };
    }

    static stringToDate(value: string | null) : Date {
        // WARNING - This method return a US formatted date string - 
        // do NOT use except for returning to a UI component, 
        // do NOT use for populating an input object for data submission
        // do NOT use for any array of dates that might need sorting
        var result = new Date();

        if (value != null) {
            //checks to see if string is in valid format before conversion
            //note: we can add multiple formats later.  For now this is the
            //expected format for dates within a tabulator.
            if (DateTime.fromISO(value).isValid) {
                result = DateTime.fromISO(value).toJSDate();
            } else if (DateTime.fromFormat(value, "LL/dd/yyyy").isValid) {
                result = DateTime.fromFormat(value, "LL/dd/yyyy").toJSDate();
            }
            //default format for date time to string
            else if (DateTime.fromFormat(value, "yyyy-LL-ddTHH:mm:ss").isValid) {
                result = DateTime.fromFormat(value, "yyyy-LL-ddTHH:mm:ss").toJSDate();
            }
            //default format for date time to string
            else if (DateTime.fromFormat(value, "yyyy-LL-ddTHH:mm").isValid) {
                result = DateTime.fromFormat(value, "yyyy-LL-ddTHH:mm").toJSDate();
            }
        }

        return result;
    }

    static stringToDateString(value: string | null) {
        var result = "";
        var dateFromString = this.stringToDate(value);

        if (value != null) {
            result = DateTime.fromJSDate(dateFromString).toFormat('LL/dd/yyyy');
        }

        return result;
    }

    static isLeftDateStringBeforeRightDateString(leftDate: string, rightDate: string) {
        var result = null;
        var left = this.stringToDate(leftDate);
        var right = this.stringToDate(rightDate);

        if (left !== null && right !== null) {
            if (left < right) {
                return true;
            }
            else {
                return false;
            }
        }

        return result;
    }

    static IsDateInFuture = function (dateValue: string) {
        var dt = dateHelper.convertToDate(dateValue);
        if (dt === null) { return false }

        var futureDate = dateHelper.formatDateToISO(dt.toString());
        var today = dateHelper.formatDateToISO(new Date().toISOString());
        return (futureDate > today);
    }

    /* calculates the age in years between the passed date and today */
    static ageInYears = function (date: string) {
        /* convert string to iso date */
        var isoDate = dateHelper.formatDateToISO(date);
        var oldDate = dateHelper.stringToDate(isoDate);
        if (!oldDate) {
            return 0;
        }

        var today = new Date();
        var diff = (today.getTime() - oldDate.getTime()) / 1000;
        diff /= (60 * 60 * 24);

        return Math.abs(diff / 365.25);
    }


    static stringDateInFormat(dateValue: string, dateFormat: string) {

        let result: string = "";

        if (isNaN(Date.parse(dateValue))) { return result; }

        //in some cases the date time value is in ISO but the format is short date
        //first check if the date time value is in ISO format, if so perform the conversion
        if (DateTime.fromISO(dateValue).isValid) {
            result = DateTime.fromISO(dateValue).toFormat(dateFormat);
        }

        // If we are here we are instructing luxon to convert according to the supplied format - and if successful we return the formatted date
        else if (DateTime.fromFormat(dateValue, dateFormat).isValid) {
            result = DateTime.fromFormat(dateValue, dateFormat).toString();
        }

        return result;
    }

    static convertToDate(dateValue: string) {
        var result: Date | null = null;

        //TODO add if statement to ensure string is in safe format
        if (isNaN(Date.parse(dateValue))) { return result }

        result = new Date(dateHelper.formatDateToISO(dateValue));
        return result;
    }

    static convertToDateOrDefault(dateValue: string | null) {
        var result: Date = new Date();
        if (!dateValue) {
            return result;
        }

        //TODO add if statement to ensure string is in safe format
        if (isNaN(Date.parse(dateValue))) { return result }

        result = new Date(dateHelper.formatDateToISO(dateValue));
        return result;
    }
    static formatDateToISO(date: string) {
        var time = "T00:00:00";
        if (isNaN(Date.parse(date))) {
            return new Date('1700/01/01').toISOString();
        }
        // Now drop the inccoming time to avoid rolling over to the next day in UTC conversion
        var isoDate = "";
        var dtISO = new Date(date);
        if (dtISO.getHours() >= 19) {
            // Assume we will roll over a day from an evening time EDT, so back up 5 hours
            var dateCopy = new Date(dtISO);
            dateCopy.setHours(dtISO.getHours() - 5);
            isoDate = dateCopy.toISOString();
        } else {
            isoDate = new Date(date).toISOString();
        }
        const d = isoDate.substring(0, 10) + time;

        return d;


    }

    static formatAMPM(date: any) {

        var hours = date ? date.getHours() : 0;
        var minutes = date ? date.getMinutes() : 0;
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    static areTwoDatePickerValuesEqual(datePickerValueOne: any, datePickerValueTwo: any) {
        var convertedDateObjectOne = new Date(datePickerValueOne);
        var convertedDateObjectTwo = new Date(datePickerValueTwo);

        return convertedDateObjectOne.getTime() == convertedDateObjectTwo.getTime();
    }

    static daysInMonth(monthName: string): number {
        let yearValue: number = DateTime.local(DateTime.local().year).year;
        let monthValue: number = this.monthNametoNumber(monthName);
        return DateTime.local(yearValue, monthValue).daysInMonth;      
    }

    static monthNametoNumber(monthName: string): number {
        const dateTime = DateTime.fromFormat(monthName, 'MMMM');
        return dateTime.month;
    }

}

